module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages-new/program/program-read/program-read.component.html
// module id = ./src/app/pages-new/program/program-read/program-read.component.html
// module chunks = main